// Field lavel validation
// const required = value => value ? undefined : 'Required';
// const maxLength = max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined;
// const maxLength15 = maxLength(15);
// const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined;

// Form validation
const validate = (values) => {
  // console.log(values)
  const error = {};
  if (!values.Email || values.Email.trim() === '') {
    error.Email = 'Please enter email address';
  }
  if (!values.LocationID) {
    error.LocationID = 'Please enter location.';
  }
  if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(values.Email)) {
    error.Email = 'Please enter a valid email address';
  }
  // if (!values.GuardianEmail || values.GuardianEmail.trim() === '') {
  //   error.GuardianEmail = 'Please enter email address';
  // }
  if (values.guardianEmail && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(values.guardianEmail)) {
    error.guardianEmail = 'Please enter a valid email address';
  }
  if (!values.otherRelationshipName || values.otherRelationshipName.trim() === '') {
    error.otherRelationshipName = 'Please enter other relationship';
  }
  if (values.Phone && values.Phone.length) {

    const PhoneArrayErrors = [];
    values.Phone.forEach((phone, phoneIndex) => {
      const phoneErrors = {};
      // console.log(phone.PhoneNumber, phone.PhoneNumber.length)
      if (!phone.PhoneNumberTypeId) {
        phoneErrors.PhoneNumberTypeId = 'Please select contact type';
        PhoneArrayErrors[phoneIndex] = phoneErrors;
      }  
      if (!phone.PhoneNumber) {
        phoneErrors.PhoneNumber = 'please enter phone number';
        PhoneArrayErrors[phoneIndex] = phoneErrors;
      } 
      else if (phone.PhoneNumber && phone.PhoneNumber.length < 14) {
        phoneErrors.PhoneNumber = 'please enter valid phone number';
        PhoneArrayErrors[phoneIndex] = phoneErrors;
      }
      // if (!phone.PreferenceID) {
      //   phoneErrors.PreferenceID = 'Please select preference';
      //   PhoneArrayErrors[phoneIndex] = phoneErrors;
      // }       
      return phoneErrors;
    });

    if (PhoneArrayErrors.length) {

      error.Phone = PhoneArrayErrors;
      // console.log('PhoneArrayErrors ->',PhoneArrayErrors)
    }
  }
  if (values.AdditionalAddress && values.AdditionalAddress.length) {

    const AdditionalAddressArrayErrors = [];
    values.AdditionalAddress.forEach((address, addressIndex) => {
      const addressErrors = {};
      // console.log(phone.PhoneNumber, phone.PhoneNumber.length)
      if (!address.AddressTypeID) {
        addressErrors.AddressTypeID = 'Please select an option';
        AdditionalAddressArrayErrors[addressIndex] = addressErrors;
      }
      if (!address.Others || address.Others.trim() === '') {
        addressErrors.Others = 'Please fill other address type';
        AdditionalAddressArrayErrors[addressIndex] = addressErrors;
      }
      if (!address.PatientLocationID) {
        addressErrors.PatientLocationID = 'Please select an option';
        AdditionalAddressArrayErrors[addressIndex] = addressErrors;
      }
      if (!address.CountryID) {
        addressErrors.CountryID = 'Please select a country';
        AdditionalAddressArrayErrors[addressIndex] = addressErrors;
      }
      if (!address.StateID && address.CountryID) {
        addressErrors.StateID = 'Please select a state';
        AdditionalAddressArrayErrors[addressIndex] = addressErrors;
      }
      if (!address.Zip) {
        addressErrors.Zip = 'Please enter zip code';
        AdditionalAddressArrayErrors[addressIndex] = addressErrors;
      }
      if (address.Zip && address.Zip.length < 5) {
        addressErrors.Zip = 'Please enter correct zip code';
        AdditionalAddressArrayErrors[addressIndex] = addressErrors;
      }
      if (!address.City || address.City.trim() === '') {
        addressErrors.City = 'Please enter a city';
        AdditionalAddressArrayErrors[addressIndex] = addressErrors;
      }
      if (!address.Address1 || address.Address1.trim() === '') {
        addressErrors.Address1 = 'Please enter address';
        AdditionalAddressArrayErrors[addressIndex] = addressErrors;
      }
      return addressErrors;
    });

    if (AdditionalAddressArrayErrors.length) {

      error.AdditionalAddress = AdditionalAddressArrayErrors;
      // console.log('PhoneArrayErrors ->',PhoneArrayErrors)
    }
  }
  // console.log('error.Phone', error.Phone)

  // if (!values.password || values.password.trim() === "") {
  //   error.password = "Please enter password.";
  // }
  // To check a password between 6 to 20 characters which contain at least
  // one numeric digit,
  // one uppercase, and //(?=.*[A-Z])
  // one lowercase letter //(?=.*[a-z])

  // let passw = /^.{6,12}$/;
  // if (values.password && !passw.test(values.password)) {
  //   error.password = "Password must be between 6 and 12 characters.";
  // }

  // if (!values.confirm_password || values.confirm_password.trim() === "") {
  //   error.confirm_password = "Please enter confirm password.";
  // }
  // if (values.password && values.confirm_password && (values.password !== values.confirm_password)) {
  //   error.confirm_password = "Password doesn\'t match with confirm password.";
  // }

  // if (!values.newpassword || values.newpassword.trim() === "") {
  //   error.newpassword = "Please enter a password.";
  // }
  // if (values.newpassword && values.confirm_password && (values.newpassword !== values.confirm_password)) {
  //   error.confirm_password = "New password doesn\'t match with confirm password.";
  // }
  //
  // if (values.newpassword && values.confirm_password && (values.newpassword !== values.confirm_password)) {
  //   error.confirm_password = "New password doesn\'t match with confirm password.";
  // }

  if (!values.FirstName || values.FirstName.trim() === '') {
    error.FirstName = 'Please enter first name';
  }
  if (!values.EmergencyContactOthers || values.EmergencyContactOthers.trim() === '') {
    error.EmergencyContactOthers = 'Please enter other relationship';
  }
  if (!values.LastName || values.LastName.trim() === '') {
    error.LastName = 'Please enter last name';
  }

  if (!values.mobile || values.mobile.trim() === '') {
    error.mobile = 'Please enter mobile number';
  }
  if (values.mobile && values.mobile.length < 14) {
    error.mobile = 'Please enter valid mobile number';
  }
  // if (!values.Phone) {
  //   error.Phone = 'Please enter phone number';
  // }
  // if (values.Phone && values.Phone.length < 14) {
  //   error.Phone = 'Please enter valid phone number';
  // }
  if (values.Zip && values.Zip.length < 5) {
    error.Zip = 'Please enter correct zip';
  }
  if (values.mailing_address_Zip && values.mailing_address_Zip.length < 5) {
    error.mailing_address_Zip = 'Please enter valid mailing address Zip';
  }
  if (values.guardianHomePhone && values.guardianHomePhone.length < 14) {
    error.guardianHomePhone = 'Please enter valid phone number';
  }
  if (values.EmergencyContactPhone && values.EmergencyContactPhone.length < 14) {
    error.EmergencyContactPhone = 'Please enter valid emergency contact phone number';
  }
  if (!values.Dob) {
    error.Dob = 'Please enter date of birth';
  }

  // if (!values.SSN || values.SSN.trim() === '') {
  //   error.SSN = 'Please enter SSN';
  // } else if (values.SSN.length !== 11) {
  //   error.SSN = 'SSN should be 11 digit number';
  // }

  if (values.SSN && values.SSN.trim() !== '' && values.SSN.length !== 11) {
    error.SSN = 'SSN should be 9 digit number';
  }

  if (!values.MRN || values.MRN.trim() === '') {
    error.MRN = 'Please enter client Id';
  }


  if (values.SecondaryRace) {
    if (!Number.isInteger(values.Race)) {
      error.SecondaryRace = 'Please select an option';
    }
  }

  if (!values.Gender) {
    error.Gender = 'Please select gender';
  } else if (!Number.isInteger(values.Gender)) {
    error.Gender = 'Incorrect gender';
  }

  if (values.Gender) {
    if (!Number.isInteger(values.Gender)) {
      error.Gender = 'Please select an option';
    }
  }

  if (!values.ICDID) {
    error.ICDID = 'Please select primary diagnosis';
  }

  if (values.IsActive) {
    if (typeof(values.IsActive) !== 'boolean') {
      error.IsActive = 'Please select an option';
    }
  }

  if (!values.DiagnosisDate) {
    error.DiagnosisDate = 'Please enter diagnosis date';
  }
  if (!values.ResolveDate) {
    error.ResolveDate = 'Please enter resolve date';
  }
  if (values.ResolveDate && values.DiagnosisDate && values.ResolveDate <= values.DiagnosisDate) {
    error.ResolveDate = 'Invalid resolve date';
  }


  // if (!values.PrimaryProvider) {
  //   error.PrimaryProvider = 'Please select primary provider';
  // }
  // if (!values.RenderingProviderID) {

  //   error.RenderingProviderID = 'Please select an option';

  // }

  if (values.SecondaryRace) {
    if (!Number.isInteger(values.SecondaryRace)) {
      error.SecondaryRace = 'Incorrect secondary race';
    }
  }
  if (values.Race) {
    if (!Number.isInteger(values.Race)) {
      error.Race = 'Incorrect race';
    }
  }


 /* if (!values.PrimaryProvider) {
    error.PrimaryProvider = 'Please select primary provider';
  } else if (!Number.isInteger(values.PrimaryProvider)) {
    error.PrimaryProvider = 'Incorrect primary provider';
  }


  // if (!values.Ethnicity) {
  //   error.Ethnicity = 'Please Select Ethnicity';
  // } else if (!Number.isInteger(values.Ethnicity)) {
  //   error.Ethnicity = 'Incorrect Ethnicity';
  // }


  if (!values.MaritalStatus) {
    error.MaritalStatus = 'Please select marital status';
  }
  if (!values.DOB) {
    error.DOB = 'Please enter date of birth';
  }/*
  if (!values.Race) {
    error.Race = 'Please select Race';
  }*/

  // @Patient Social History - validations

  if (!Number.isInteger(values.alcohalID)) {
    error.alcohalID = 'Please select an option';
  }
  if (!Number.isInteger(values.tobaccoID)) {
    error.tobaccoID = 'Please select an option';
  }
  if (!Number.isInteger(values.drugID)) {
    error.drugID = 'Please select an option';
  }
  if (!Number.isInteger(values.travelID)) {
    error.travelID = 'Please select an option';
  }


  // @Patient Address - Validations

  if (!values.primary_address_Address1) {
    error.primary_address_Address1 = 'Please enter address';
  }
  if (!values.primary_address_City) {
    error.primary_address_City = 'Please enter a city';
  }

  if (!values.primary_address_StateID && values.primary_address_CountryID) {
    error.primary_address_StateID = 'Please select a state';
  } else if (!Number.isInteger(values.primary_address_StateID)) {
    error.primary_address_StateID = 'Please select an option';
  }

  if (!values.primary_address_CountryID) {
    error.primary_address_CountryID = 'Please select a country';
  } else if (!Number.isInteger(values.primary_address_CountryID)) {
    error.primary_address_CountryID = 'Please select an option';
  }

  if (!values.primary_address_Zip) {
    error.primary_address_Zip = 'Please enter zip code';
  }
  if (values.primary_address_Zip && values.primary_address_Zip.length < 5) {
    error.primary_address_Zip = 'Please enter correct zip code';
  }

  if (!values.primary_address_PatientLocationID) {
    error.primary_address_PatientLocationID = 'Please select an option';
  }

  // mailing address validations
  if (!values.mailing_address_Address1) {
    error.mailing_address_Address1 = 'Please enter address';
  }
  if (!values.mailing_address_City) {
    error.mailing_address_City = 'Please enter a city';
  }

  if (!values.mailing_address_StateID && values.mailing_address_CountryID) {
    error.mailing_address_StateID = 'Please select a state';
  }

  if (!values.mailing_address_CountryID) {
    error.mailing_address_CountryID = 'Please select a country';
  }

  if (!values.mailing_address_Zip) {
    error.mailing_address_Zip = 'Please enter zip code';
  }
  if (values.mailing_address_Zip && values.mailing_address_Zip.length < 5) {
    error.mailing_address_Zip = 'Please enter correct zip code';
  }

  if (!values.mailing_address_PatientLocationID) {
    error.mailing_address_PatientLocationID = 'Please select an option';
  }

  // @Patient Insurance - Validations
  // these validations are moved to insurance form itself due to simillar name problem with phone array and this single phone field's validations.
  // if (!values.InsuranceCompanyID) {
  //   error.InsuranceCompanyID = 'Please select insurance company';
  // }

  // if (!values.insFirstName) {
  //   error.insFirstName = 'Please enter first name';
  // }

  // // console.log('values.insLastName: ', values.insLastName);
  // if (!values.insLastName || values.insLastName.trim() === '') {
  //   error.insLastName = 'Please enter last name';
  // }

  // if (!values.City || values.City.trim() === '') {
  //   error.City = 'Please enter a city';
  // }

  // if (!values.insRelationship) {
  //   error.insRelationship = 'Please select relationship';
  // } else if (!Number.isInteger(values.insRelationship)) {
  //   error.insRelationship = 'Incorrect relationship';
  // }

  // if (!values.Gender) {
  //   error.Gender = 'Please select gender';
  // } else if (!Number.isInteger(values.Gender)) {
  //   error.Gender = 'Incorrect gender';
  // }

  // if (!values.State) {
  //   error.State = 'Please select state';
  // } else if (!Number.isInteger(values.State)) {
  //   error.State = 'Incorrect state';
  // }

  // if (!values.Country) {
  //   error.Country = 'Please select country';
  // } else if (!Number.isInteger(values.Country)) {
  //   error.Country = 'Incorrect country';
  // }

  // if (!values.InsuranceIDNumber) {
  //   error.InsuranceIDNumber = 'Please enter insurance id number';
  // }
  // if (!values.InsuranceIDNumber) {
  //   error.InsuranceIDNumber = 'Please enter insurance id number';
  // }
  // // if (!values.InsurancePlanName) {
  // //   error.InsurancePlanName = 'Please enter insurance plan name';
  // // }
  // if (!values.InsurancePlanTypeID) {
  //   error.InsurancePlanTypeID = 'Please select insurance plan type';
  // }
  // patient illness -Validations
  if (!values.Illness) {
    error.Illness = 'Please enter a disease';
  }
  if (!values.StatusID) {
    error.StatusID = 'Please select status';
  }
  // patient immunization -Validations

  if (!values.immunization) {
    error.immunization = 'Please select immunization';
  }

  if (values.Immunization) {
    if (!Number.isInteger(values.Immunization)) {
      error.Immunization = 'Please select an option';
    }
  }

  if (values.vfcid) {
    if (!Number.isInteger(values.vfcid)) {
      error.vfcid = 'Please select an option';
    }
  }

  if (values.manufactureID) {
    if (!Number.isInteger(values.manufactureID)) {
      error.manufactureID = 'Please select an option';
    }
  }

  if (values.administrationSiteID) {
    if (!Number.isInteger(values.administrationSiteID)) {
      error.administrationSiteID = 'Please select an option';
    }
  }

  if (values.orderBy) {
    if (!Number.isInteger(values.orderBy)) {
      error.orderBy = 'Please select an option';
    }
  }

  if (values.administeredBy) {
    if (!Number.isInteger(values.administeredBy)) {
      error.administeredBy = 'Please select an option';
    }
  }


  if (values.rejectionReasonID && (values.rejectedImmunization === true)) {
    if (!Number.isInteger(values.rejectionReasonID)) {
      error.rejectionReasonID = 'Please select an option';
    }
  }
  if (!values.rejectionReasonID && (values.rejectedImmunization === true)) {
    error.rejectionReasonID = 'Please select an option';
  }
  if (!values.routeOfAdministrationID) {
    error.routeOfAdministrationID = 'Please select route of administration';
  }

  if (values.routeOfAdministrationID) {
    if (!Number.isInteger(values.routeOfAdministrationID)) {
      error.routeOfAdministrationID = 'Please select an option';
    }
  }

  if (!values.immunityStatusID) {
    error.immunityStatusID = 'Please select immunity status';
  }

  if (values.immunityStatusID) {
    if (!Number.isInteger(values.immunityStatusID)) {
      error.immunityStatusID = 'Please select an option';
    }
  }

  if (!values.administeredDate) {
    error.administeredDate = 'Please select administered date';
  }
  if (!values.expireDate) {
    error.expireDate = 'Please select expiration date';
  }
  if (values.expireDate && values.administeredDate) {
    if (values.expireDate <= values.administeredDate) {
      error.expireDate = 'Invalid expiration date';
    }
  }

  // validations for parent/guardian
  if (!values.guardianFirstName || values.guardianFirstName.trim() === '') {
    error.guardianFirstName = 'Please enter first name';
  }

  if (!values.guardianLastName || values.guardianLastName.trim() === '') {
    error.guardianLastName = 'Please enter last name';
  }
  if (!values.relationshipID || !Number.isInteger(values.relationshipID)) {
    error.relationshipID = 'Please select a relationship';
  }
  if (values.relationshipID) {
    if (!Number.isInteger(values.relationshipID)) {
      error.relationshipID = 'Please select an option';
    }
  }

  return error;
};

export default validate;



// WEBPACK FOOTER //
// ./src/modules/patients/validate.js